<template>
	<div class="buy-footer">
		<div class="container">
			<div class="contact">
				<img src="https://static.landui.com/statics/images/public/foot-logo.png">
				<div class="left">
					<p class="tel">服务热线：<br>4006-75-4006<span>(7*24小时在线)</span></p>
					<p class="time">总机直拨：<br>0871-63886388（工作日9:00-18:00）</p>
					<h5>Copyright © 2012 - {{ currentYear }} LanDui.com. All RightsReserved.　蓝队云 版权所有</h5>
				</div>
				<ul>
					<li class="qq"><a :href="domain + '/index/index/qq/'" id="qqfoot" target="_blank"></a></li>
					<li class="weixin">
						<a href="javascript:void(0)"></a>
						<p><i></i><img src="https://static.landui.com/statics/images/public/fwh.jpg" width="110" height="110" alt="蓝队微信"></p>
					</li>
					<li class="weibo">
						<a href="javascript:void(0)"></a>
						<p><i></i><img src="https://static.landui.com/statics/images/public/wb.jpg" width="110" height="110" alt="蓝队微博"></p>
					</li>
					<li class="mail">
						<a href="mailto:kefu@landui.com" target="_blank"></a>
					</li>
				</ul>
			</div>
			<div class="main">
				<ul class="foot-menu">
					<li>
						<h4>关于蓝队云</h4>
						<a :href="domain + '/help/aboutus/'" title="关于我们">关于我们</a>
						<a :href="domain + '/help/course/'" title="发展历程">发展历程</a>
						<a :href="domain + '/help/qualification/'" title="资质荣誉">资质荣誉</a>
						<a :href="domain + '/help/notice/'" title="新闻公告">新闻公告</a>
						<a :href="domain + '/help/job/'" title="诚聘英才">诚聘英才</a>
						<a :href="domain + '/help/contact/'" title="联系我们">联系我们</a>
						<a :href="domain + '/help/ilist-0/'" title="资讯中心">资讯中心</a>
					</li>
					<li>
						<h4>蓝队云产品</h4>
						<a :href="domain + '/cloud/'" title="云服务器">云服务器</a>
						<a :href="domain + '/hosting/'" title="虚拟主机">虚拟主机</a>
						<a :href="domain + '/server/collocation/'" title="服务器托管">服务器托管</a>
						<a :href="domain + '/server/'" title="服务器租用">服务器租用</a>
						<a :href="domain + '/ssl/'" title="SSL证书">SSL证书</a>
						<a :href="domain + '/domain/'" title="域名注册">域名注册</a>
					</li>
					<li>
						<h4>服务与支持</h4>
						<a :href="domain + '/docs-list-61.html'" title="云服务器问题">云服务器问题</a>
						<a :href="domain + '/docs-list-196.html'" title="网站备案指南">网站备案指南</a>
						<a :href="domain + '/list-39.html'" title="租用管托知识">租用管托知识</a>
						<a :href="domain + '/docs-10694.html'" title="域名注册问题">域名注册问题</a>
						<a :href="domain + '/docs-10175.html'" title="SSL证书安装">SSL证书安装</a>
						<a :href="domain + '/help/'" title="技术问题索引">技术问题索引</a>
					</li>
					<li>
						<h4>快速通道</h4>
						<a :href="domain + '/domain/whois/'" title="域名whois查询">域名whois查询</a>
						<a :href="domain + '/rdap/'" title="域名rdap查询服务">域名rdap查询服务</a>
						<a :href="domain + '/index/user/appeal/'" title="账号申诉" target="_blank">账号申诉</a>
					</li>
				</ul>
				<div class="foot-link">
					<a :href="domain + '/city/'" target="_blank">全国域名注册</a>
					<a href="http://www.hf960.com/" target="_blank">航帆网</a>
					<a href="http://www.ynshangji.com" target="_blank">云南商机网</a>
					<a href="http://www.ip138.com/idc/" target="_blank">IDC公司大全</a>
					<a href="http://www.9ji.com/" target="_blank">九机网</a>
				</div>
				<ul class="foot-honor">
					 <li class="item1">工信部备案号  <a href="http://beian.miit.gov.cn/" target="_blank">滇ICP备05000110号-1</a></li>
					 <li class="item2">滇公安备案  <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=53010302000111" target="_blank">滇53010302000111</a></li>
					 <li class="item1">增值电信业务经营许可证  <a href="https://static.landui.com/statics/images/about/zizhi/b14.jpg" target="_blank">B1.B2-20181647</a>、<a href="https://static.landui.com/statics/images/about/zizhi/b16.jpg" target="_blank">滇B1.B2-20190004</a></li>
				 </ul>
				 <ul class="foot-honor foot-text">
					 <li class="item3"><a href="https://www.ynnet.org.cn/cert-3.html" target="_blank">云南互联网协会理事单位</a></li>
					 <li class="item4"><a href="https://v.yunaq.com/certificate?domain=www.landui.com" target="_blank">安全联盟认证网站身份V标记</a></li>
					 <li>域名注册服务机构许可：<a href="https://domain.miit.gov.cn/%E5%9F%9F%E5%90%8D%E6%B3%A8%E5%86%8C%E6%9C%8D%E5%8A%A1%E6%9C%BA%E6%9E%84/%E4%BA%92%E8%81%94%E7%BD%91%E5%9F%9F%E5%90%8D/%E4%BA%91%E5%8D%97%E8%93%9D%E9%98%9F%E4%BA%91%E8%AE%A1%E7%AE%97%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8" target="_blank">滇D3-20230001</a></li>
					 <li>代理域名注册服务机构：新网数码</li>
				 </ul>
			</div>
		</div>
	</div>
</template>

<script setup>
	import {inject } from 'vue';
	
	const domain = inject('domain');
	const currentYear = new Date().getFullYear();
	
</script>

<style lang="scss">
	.buy-footer{
		min-width: 1280px;
		background: #191c22;
		padding: 75px 0 45px;
		overflow: hidden;
		.container{width: 1280px;margin: 0 auto;}
		.contact{
			float: left;
			width: 320px;
			.left{
				margin-top: 50px;
				overflow: hidden;
				p{font-size: 18px;line-height: 32px;color: #fff;}
				h5 {
				    margin-top: 40px;
				    font-size: 14px;
				    color: #a1a7b2;
				    line-height: 22px;
				}
			}
			ul{ 
				height: 38px; 
				margin:45px 0 0; 
				li{ 
					position: relative; 
					width:30px; 
					height:30px; 
					float: left; 
					margin-right: 20px; 
					a{ display: block;width:30px; height:30px;background: url("https://static.landui.com/statics/images/public/icons.png?v=1") no-repeat;}
					i{display: inline-block; position: absolute; bottom: -6px; left:55px;width: 0;height: 0;line-height: 0;vertical-align: middle;border:6px dashed transparent;border-top-style: solid;border-top-color: #fff;border-bottom-width: 0;}
					p{ display: none;position: absolute; left: -48px; bottom: 38px;background: #fff; padding:5px;}
					img{ display: block; margin:0 auto;}
				}
				li:hover p{display: block;}
				.weixin a{ background-position:1px 2px;}
				.weixin a:hover{ background-position:-172px 3px;}
				.qq a{ background-position: -40px 2px;}
				.qq a:hover{ background-position: -213px 2px;}
				.weibo a{ background-position: -81px 2px;}
				.weibo a:hover{ background-position: -254px 3px;}
				.mail a{ background-position: -127px 2px;}
				.mail a:hover{ background-position: -299px 3px;}
			}
		}
		.main{
			width: 850px;
			float: right;
		}
		.foot-menu{
			margin-bottom:45px; 
			overflow: hidden;
			li{ 
				float: left;
				width:160px; 
				margin-right:70px;
				h4{ font-size: 16px; color: #fff; padding: 0 0 26px; border-bottom: 1px solid #303339; margin: 0 0 15px;}
				a{ display: block; color: #5e646e; line-height:30px;}
				a:hover{ color:#d1d9e8;}
			}
			li:last-child{ margin-right: 0}
		}
		.foot-link{ 
			clear: both; 
			position: relative; 
			padding:20px 0 10px 84px;
			line-height: 22px; 
			border-top: 1px solid #303339;
			overflow: hidden;
			a{ display: inline-block; color: #5e646e;margin:0 20px 15px 0;}
			a:hover{ color:#d1d9e8;}
		}
		.foot-link:before{ content: "友情链接："; color: #fff; display: inline-block;height: 22px; position: absolute; left: 0; top:20px;}
		.foot-honor{ 
			font-size: 12px; 
			padding-top:15px;
			border-top: 1px solid #303339;
			overflow:hidden;
			li{ 
				display: inline-block; 
				height:24px;
				line-height: 24px;
				color: #5e646e; 
				margin-right:22px;
				a{display:inline-block;color: #5e646e;}
				a:hover{color: #fff;}
			}
			li:last-child{ margin-right: 0}
			.item1{ padding-left: 24px;background:url("https://static.landui.com/statics/images/public/foot-logo1.png") left center no-repeat}
			.item2{ padding-left: 24px;background:url("https://static.landui.com/statics/images/public/foot-logo2.png") left center no-repeat}
			.item3{ padding-left: 35px;background:url("https://static.landui.com/statics/images/public/foot-logo3.png") left center no-repeat}
			.item4{ padding-left: 28px;background:url("https://static.landui.com/statics/images/public/foot-logo4.png") left center no-repeat}
		}
		.foot-text{border: 0}
	}
	.float-consult{
		position: fixed; 
		right: 20px; 
		bottom:100px;
		z-index:111;
		ul{ 
			position: relative;
			li{ 
				width: 90px; 
				height:55px;
				margin: 0 0 5px;
				.cloumn{ float: right; width:55px; height: 55px; background: #fff;  text-align: center; font-size: 12px; color: #666666; border: 1px solid #eee; cursor: pointer;}
				.cloumn:before{ content: ""; width: 26px; height: 26px; display: block; margin:5px auto 2px; background: url("https://static.landui.com/statics/images/public/side-menu.png") no-repeat;}
				.cs1:before{ background-position: 1px 0;}
				.cs2:before{ background-position: -27px 0;}
				.cs3:before{ background-position: -56px 0;}
				.cs4:before{ background-position: -85px 0;}
				.cs5:before{ background-position: -116px 0;}
				.cs6:before{ background-position: -145px 0;}
				.cs7:before{ background-position: -176px 0;}
				.cs8:before{ background-position: -206px 0;}
				.cs9:before{ background-position: -95px -86px;}
				.ewm{ 
					display: none; 
					position: absolute;
					bottom:-5px; 
					right:69px; 
					z-index: 111; 
					background: #fff;
					width:130px; 
					height: 130px; 
					border: 1px solid #059fff;
					img{ display: block; width: 118px; height: 118px; margin: 5px; }
				}
				.ewm:after{ content: ""; width:5px; height:8px; display: block; position: absolute; right:-5px; top:30px; background: url("https://static.landui.com/statics/images/public/ico/ico2.png") left center no-repeat; }
				.version{ 
					display: none; 
					position: absolute;
					top:0; 
					right:69px; 
					z-index: 111; 
					background: #fff;
					width:130px; 
					height: 130px; 
					border: 1px solid #059fff;
					img{ display: block; width: 118px; height: 118px; margin: 5px; }
				}
				.version:after{ content: ""; width:5px; height:8px; display: block; position: absolute; right:-5px; top:30px; background: url("https://static.landui.com/statics/images/public/ico/ico2.png") left center no-repeat; }
				.service{ display: none; position: absolute; top: 240px; right:70px; font-size: 16px; color: #fff; width: 210px; background: #059fff; text-align: center; line-height: 25px; padding:18px 0; }
				.service:after{ content: ""; position: absolute; right: -5px; top: 26px; display: inline-block;width: 0;height: 0;line-height: 0;vertical-align: middle;border:5px dashed transparent;border-left-style: solid;border-left-color: #059fff;border-right-width: 0;}
				.consult{ 
					display: none; 
					border: 1px solid #eee; 
					width: 325px; 
					background:#fff; 
					position: absolute; 
					right:70px; 
					top: 0;
					h2{ 
						font-size: 20px; 
						padding: 13px 20px 13px; 
						margin: 0 0 15px;
						border-bottom: 1px dashed #ddd;
						span{color: #999999; font-size: 14px; margin-left:15px;}
					}
				}
				.consult:before{ content: ""; display: block; width: 6px; height: 10px; position: absolute; right: -5px;background: url("https://static.landui.com/statics/images/public/ico/ico4.png") center no-repeat; }
				.item{ 
					height: 40px; 
					border: 1px solid #eeeeee; 
					position: relative; 
					padding-left: 140px; 
					text-align: center; 
					min-height: 38px; 
					margin: 0 0 15px;
					em{ display: block; width: 139px;height: 38px; line-height: 38px; background: #fafafa; position: absolute; left: 0; top: 0;color: #666666; }
					img{ display: block; width:89px; height:89px;}
					.ico{ display: inline-block; width: 20px; height: 20px; position: relative; margin:9px 10px 0; vertical-align: middle; cursor: pointer; background: url("https://static.landui.com/statics/images/public/side-menu.png") no-repeat;}
					.card{ display: none; position: absolute; bottom: -98px; left:-37px; z-index: 111; background: #fff;width: 90px; height: 90px; border: 1px solid #059fff;}
					.card:before{ content: ""; width: 9px; height: 6px; display: block; position: absolute; left: 41px; top: -6px; background: url("https://static.landui.com/statics/images/public/ico/ico3.png") center bottom no-repeat; }
					.phone{ display: none; position: absolute;  bottom: -45px; left:-65px;font-size: 16px; z-index: 111; color: #fff; width:150px; background: #059fff; text-align: center; line-height: 25px; padding:7px 0; }
					.phone:after{ content: ""; position: absolute; left: 70px; top:-5px; display: inline-block;width: 0;height: 0;line-height: 0;vertical-align: middle;border:5px dashed transparent;border-bottom-style: solid;border-bottom-color: #059fff;border-top-width: 0;}
				}
				.item p:hover{
					span{display: block;}
				}
				.list{
					border-bottom: 1px dashed #eee; 
					padding:0 20px 15px;
					.qq{ background-position: 0 -60px;}
					.wx{background-position: -22px -60px;}
					.tel{background-position: -50px -60px;}
					.qq:hover{ background-position: -71px -60px;}
					.wx:hover{background-position: -94px -60px;}
					.tel:hover{background-position: -120px -60px;}
				}
				.tip{
					font-size:12px; 
					overflow: hidden;
					h5{ color: #ff8a00; font-size:14px; margin:0 0 5px;}
					p{ color:#666; line-height:20px;}
					span{ font-weight:600;}
				}
				.preale:before{ top: 22px;}
				.preale3{
					.card{ top: -98px;}
					.card:before{ top:89px;background: url("https://static.landui.com/statics/images/public/ico/ico3-1.png") center bottom no-repeat; }
				}
				.preale4{
					.phone{ bottom:33px;}
					.phone:after{ bottom:-5px; top:auto;border-top-width: thick; border-bottom-style: none; border-top-style: solid; border-top-color: #059fff; border-bottom-width: 0;}
					.card{ top: -98px;}
					.card:before{ top:89px;background: url("https://static.landui.com/statics/images/public/ico/ico3-1.png") center bottom no-repeat; }
				}
				.aftersale:before{ top: 83px;}
				.beian:before{ top:140px;}
				.other{ 
					clear:both; 
					padding: 20px 20px 10px;
					overflow:hidden;
					h3{ color: #059fff; font-size: 14px; margin: 0 0 10px; }
					a{ display: block; color: #999999; font-size: 12px; line-height:20px; }
					a:hover{ color:#059fff;}
				}
			}
			li:hover{
				.consult{display: block;}
				.cloumn{ border: 1px solid #059fff; color: #059fff;}
				.cs1:before{ background-position: 1px -30px;}
				.cs2:before{ background-position: -27px -28px;}
				.cs3:before{ background-position: -56px -28px;}
				.cs4:before{ background-position: -85px -28px;}
				.cs5:before{ background-position: -116px -28px;}
				.cs6:before{ background-position: -145px -28px;}
				.cs7:before{ background-position: -176px -27px;}
				.cs8:before{ background-position: -206px -27px;}
				.cs9:before{ background-position: -128px -86px;}
			}
		}
	}
</style>